import { createContext, useContext, useState } from 'react';

const ReportAttendanceOperatorContext = createContext();

const initialState = {};
const initialFilterState = {
  page: 1,
  limit: 10,
  search: '',
  monthYear: new Date(),
};

const ReportAttendanceOperatorProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));

  return (
    <ReportAttendanceOperatorContext.Provider value={{ updateState, ...state, updateFilterState, filterState }}>
      {children}
    </ReportAttendanceOperatorContext.Provider>
  );
};

export const useReportAttendanceOperatorState = () => {
  return useContext(ReportAttendanceOperatorContext);
};

export default ReportAttendanceOperatorProvider;
